"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _AllocateCredits = _interopRequireDefault(require("./AllocateCredits"));

var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));

require("../styles/_manage-credits.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GRAPH_SCROLL_CONTAINER = '.submissions-graph__wrapper';

var ManageCredits = /*#__PURE__*/function (_Component) {
  _inherits(ManageCredits, _Component);

  var _super = _createSuper(ManageCredits);

  function ManageCredits() {
    var _this;

    _classCallCheck(this, ManageCredits);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var graphElement;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchMonthlySubmissions();

            case 2:
              graphElement = document.querySelector(GRAPH_SCROLL_CONTAINER);

              if (graphElement) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              graphElement.scrollTo({
                left: graphElement.scrollWidth,
                behavior: 'smooth'
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchMonthlySubmissions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var getMonthlySubmissions, _yield$getMonthlySubm, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getMonthlySubmissions = _this.props.getMonthlySubmissions;
              _context2.next = 3;
              return getMonthlySubmissions();

            case 3:
              _yield$getMonthlySubm = _context2.sent;
              data = _yield$getMonthlySubm.data;
              error = _yield$getMonthlySubm.error;

              if (!(!data || !data.getMonthlySubmissions || error)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              _this.setState({
                monthlySubmissions: data.getMonthlySubmissions
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleToggleModal", function () {
      var currentStatus = _this.state.isModalOpen;

      _this.setState({
        isModalOpen: !currentStatus
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreditTypeChange", function (_ref3) {
      var value = _ref3.value;
      var creditType = _this.props.creditType;

      if (value === creditType) {
        return;
      }

      _this.setState({
        isModalOpen: false,
        isConfirmModalOpen: true,
        newCreditTypeValue: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleConfirmModalClose", function () {
      _this.setState({
        isConfirmModalOpen: false,
        isModalOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleConfirmUpdateCreditType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, changeCreditType, onUpdateCreditType, onCreditsUpdated, newCreditTypeValue;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, changeCreditType = _this$props.changeCreditType, onUpdateCreditType = _this$props.onUpdateCreditType, onCreditsUpdated = _this$props.onCreditsUpdated;
              newCreditTypeValue = _this.state.newCreditTypeValue;
              _context3.next = 4;
              return changeCreditType({
                creditType: newCreditTypeValue
              });

            case 4:
              onUpdateCreditType(newCreditTypeValue);
              onCreditsUpdated();

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _this.state = {
      isModalOpen: false,
      newCreditTypeValue: void 0,
      monthlySubmissions: [],
      isConfirmModalOpen: false
    };
    return _this;
  }

  _createClass(ManageCredits, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          organisationId = _this$props2.organisationId,
          creditBalance = _this$props2.creditBalance,
          creditType = _this$props2.creditType,
          teams = _this$props2.teams,
          onUpdateOrgBalance = _this$props2.onUpdateOrgBalance,
          onUpdateTeams = _this$props2.onUpdateTeams,
          videoQuantity = _this$props2.orgPackage.videoQuantity,
          onCreditsUpdated = _this$props2.onCreditsUpdated;
      var _this$state = this.state,
          isModalOpen = _this$state.isModalOpen,
          newCreditTypeValue = _this$state.newCreditTypeValue,
          isConfirmModalOpen = _this$state.isConfirmModalOpen,
          monthlySubmissions = _this$state.monthlySubmissions;
      var isUnlimited = videoQuantity === -1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "manage-credits"
      }, /*#__PURE__*/_react.default.createElement(_AllocateCredits.default, {
        organisationId: organisationId,
        visible: isModalOpen,
        onClose: this.handleToggleModal,
        creditBalance: creditBalance,
        creditType: creditType,
        onCreditTypeChange: this.handleCreditTypeChange,
        teams: teams,
        onUpdateOrgBalance: onUpdateOrgBalance,
        onUpdateTeams: onUpdateTeams,
        onCreditsUpdated: onCreditsUpdated
      }), newCreditTypeValue ? /*#__PURE__*/_react.default.createElement(_ConfirmationModal.default, {
        visible: isConfirmModalOpen,
        newCreditTypeValue: newCreditTypeValue,
        onConfirmation: this.handleConfirmUpdateCreditType,
        onClose: this.handleConfirmModalClose
      }) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "manage-credits__label"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        prefixIcon: "credits",
        heading3: true,
        noMargin: true
      }, "Credits"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: this.handleToggleModal
      }, "Manage Credits")), /*#__PURE__*/_react.default.createElement("div", {
        className: "manage-credits__container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "manage-credits__container__organisation-credits"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
        rounded: true,
        className: "manage-credits__container__organisation-credits__graph"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.SubmissionsGraph, {
        monthlySubmissions: monthlySubmissions
      })), /*#__PURE__*/_react.default.createElement(_commonReact.CreditsOverview, {
        isUnlimited: isUnlimited,
        creditBalance: creditBalance,
        monthlySubmissions: monthlySubmissions
      }))));
    }
  }]);

  return ManageCredits;
}(_react.Component);

var _default = ManageCredits;
exports.default = _default;